/** Strip lightweight markdown emphasis from agent/tool display strings. */
export function normalizeChatDisplayText(value: string): string {
  return value
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .replace(/\*([^*]+)\*/g, "$1")
    .replace(/__([^_]+)__/g, "$1")
    .trim();
}
